import React, { useState, useEffect } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Stepper, Step, StepLabel, TextField } from '@mui/material';
import AssayForm from './AssayForm';
import AssayAccess from "./AssayAccess";
import axiosInstance from '../utils/axios';
import { ConstructionOutlined } from '@mui/icons-material';

const AssayConfigurationWizard = ({ inputConfig, open, onClose, onSubmit, stepPosition }) => {
    const [config, setConfig] = useState({
        approved_users: [],
        assay_name: '',
        config_directory: '',
        status: 'NEW',
        config_type: 'Assay',
        cro_contact: '',
        data_file_cro: '',
        data_file_program: '',
        labels: '',
        plugin: 'acas_assay',
        preprocessor: 'standard_preprocessor',
        validator: 'standard_validator',
        loader: 'standard_loader',
        point_of_contact_id: '',
        provider_organization_id: '',
        issue_program_id: '',
    });
    const [activeStep, setActiveStep] = useState(0);
    const [error, setError] = useState(null);
    const steps = ['Assign Assay', 'Manage Access'];

    useEffect(() => {
        if (inputConfig != null) {
            if (inputConfig["provider_organization"] != null) {
                inputConfig["provider_organization_id"] = inputConfig["provider_organization"]["id"];
            }
            if (inputConfig["issue_program"] != null) {
                inputConfig["issue_program_id"] = inputConfig["issue_program"]["id"];
            }
            if (inputConfig["point_of_contact"] != null) {
                inputConfig["point_of_contact_id"] = inputConfig["point_of_contact"]["id"];
            }
            setConfig(inputConfig);
            setActiveStep(stepPosition);
        }

        console.dir("AssayConfigurationWizard")
        console.dir("AssayConfigurationWizard")

    }, [inputConfig, stepPosition]);



    const handleFormChange = (updatedConfig) => {
        console.dir("Wizards updatedConfig:")
        console.dir(updatedConfig)
        setConfig(updatedConfig);
    };

    const handleNext = () => {
        setActiveStep((prevStep) => prevStep + 1);
    };

    const handleBack = () => {
        setActiveStep((prevStep) => prevStep - 1);
    };

    const handleSave = async (e) => {
        console.dir("in handle Save...")
        let return_config = await onAssaySubmit(e, config);
        onSubmit(e, return_config);
    };

    const onAssaySubmit = async (e, config) => {
        e.preventDefault();

        try {
            let cleaned_config = structuredClone(config);
            console.log("Submitting...2")
            console.dir(cleaned_config)

            if (cleaned_config["approved_users"]) {
                cleaned_config["approved_users_ids"] = cleaned_config["approved_users"].map(user => user.id);
                delete cleaned_config["approved_users"]
            }

            console.dir(cleaned_config)

            delete cleaned_config["approved_users"]
            delete cleaned_config["issue_program"]
            delete cleaned_config["point_of_contact"]
            delete cleaned_config["provider_organization"]
            delete cleaned_config["cro_contact"]
            delete cleaned_config["name"]

            console.dir("Update complete " + cleaned_config.id)

            if (cleaned_config.id == null) {
                cleaned_config.status = "ACTIVE"
                let response = await axiosInstance.post('issue_configurations/', cleaned_config);
                console.dir("new created")
                console.dir(response.data)
                return response.data
            } else {
                let response = await axiosInstance.put(`issue_configurations/${cleaned_config.id}/`, cleaned_config);
                console.dir("Update complete " + cleaned_config.id)
                console.dir(response.data)
                return response.data            
            }

        } catch (error) {
            console.dir(error)
            setError('Error saving folder configuration');
        }
    }

    return (
        <div>
            <Dialog open={open} onClose={onClose} fullWidth={true} maxWidth="lg"
                sx={{
                    '& .MuiDialog-paper': {
                        minWidth: '1000px',
                        maxWidth: '1000px',
                    },
                }}
            >
                {/* <DialogTitle>{`Onboard New Assay Stream: ${steps[activeStep]} (Step ${activeStep + 1} of ${steps.length})`}</DialogTitle> */}
                <DialogTitle>{`Onboard New Assay Stream (Step ${activeStep + 1} of ${steps.length})`}</DialogTitle>
                <DialogContent>
                    {error && <div className="error-message">{error}</div>}
                    <Stepper activeStep={activeStep}>
                        {steps.map((label, index) => (
                            <Step key={index}>
                                <StepLabel>{label}</StepLabel>
                            </Step>
                        ))}
                    </Stepper>
                    {activeStep === 0 && (
                        <AssayForm
                            inputConfig={config}
                            onChange={handleFormChange}
                        />
                    )}

                    {activeStep === 1 && (
                        <AssayAccess
                            inputConfig={config}
                            onChange={handleFormChange}
                        />
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={onClose} color="primary">
                        Cancel
                    </Button>
                    {activeStep > 0 && (
                        <Button onClick={handleBack} color="primary">
                            Back
                        </Button>
                    )}
                    {activeStep === steps.length - 1 ? (
                        <Button onClick={handleSave} color="primary" variant="contained">
                            Finish
                        </Button>
                    ) : (
                        <Button onClick={handleNext} color="primary" variant="contained">
                            Next
                        </Button>
                    )}
                </DialogActions>
            </Dialog>
        </div>
    );
};

export default AssayConfigurationWizard;
